
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class FranchiseeSalesReportDialog extends Serenity.EntityDialog<FranchiseeSalesReportRow, any> {
        protected getFormKey() { return FranchiseeSalesReportForm.formKey; }
        protected getIdProperty() { return FranchiseeSalesReportRow.idProperty; }
        protected getLocalTextPrefix() { return FranchiseeSalesReportRow.localTextPrefix; }
        protected getNameProperty() { return FranchiseeSalesReportRow.nameProperty; }
        protected getService() { return FranchiseeSalesReportService.baseUrl; }
        protected getDeletePermission() { return FranchiseeSalesReportRow.deletePermission; }
        protected getInsertPermission() { return FranchiseeSalesReportRow.insertPermission; }
        protected getUpdatePermission() { return FranchiseeSalesReportRow.updatePermission; }

        protected form = new FranchiseeSalesReportForm(this.idPrefix);

    }
}